module.exports = __webpack_public_path__ + "static/media/CTLI_9-147w.4d4fd2fc.jpg";